export default __webpack_public_path__ + "static/media/website.60b180d6.png";